import NoContentMessage from "@/components/NoContentMessage";
import styles from "@/styles/Search.module.scss";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SearchNoResults(_ref) {
  let {
    searchQuery
  } = _ref;
  let text = "スポーツの競技名やチーム名、アーティスト名、番組タイトル、出演者などを入れて検索してください。";
  return /*#__PURE__*/_jsx(NoContentMessage, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.noresults,
      children: [searchQuery && searchQuery.length > 0 && /*#__PURE__*/_jsxs("h3", {
        children: ["\u300C", searchQuery, "\u300D\u306B\u4E00\u81F4\u3059\u308B\u756A\u7D44\u304C\u3042\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002"]
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("span", {
          className: "fa fa-exclamation-circle"
        }), "\u30D2\u30F3\u30C8"]
      }), /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx("li", {
          children: "\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5909\u3048\u3066\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044"
        }), /*#__PURE__*/_jsx("li", {
          children: text
        })]
      })]
    })
  });
}